import { render, staticRenderFns } from "./UserProgressTracker.vue?vue&type=template&id=dfc5a1ee&scoped=true"
import script from "./UserProgressTracker.vue?vue&type=script&lang=js"
export * from "./UserProgressTracker.vue?vue&type=script&lang=js"
import style0 from "./UserProgressTracker.vue?vue&type=style&index=0&id=dfc5a1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc5a1ee",
  null
  
)

export default component.exports